import { NotesManagerContent } from "@/features/notes-manager";
import { GeneralNotesTabsContent } from "@/pages/ContactsPage/Components/GeneralNotesTabsContent";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { useNotesManager } from "../model";

export const CommitmentsTab = () => {
  const notesManager = useNotesManager();

  return (
    <GeneralNotesTabsContent
      noteManager={
        <NotesManagerContent
          notesManager={notesManager}
          noteType={DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT}
          contactsPage
        />
      }
    />
  );
};
